import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import Review from './Review';
import BotStoreTickets from './BotStoreTickets';
class BotStoreReportTabSetting extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/reports/bot-store";
            var path1 = window.origin + "/platform/projectmgmt/reports/bot-store/";
            if (currentPath === path || currentPath === path1) {
                $("#review-tab").addClass('active');
            } else if (currentPath.includes('/projectmgmt/reports/bot-store/tickets')) {
                $("#tickets-tab").addClass('active');
            }
            $("#review-tab,#tickets-tab")
                .on("click", function () {
                    $("#review-tab,#tickets-tab")
                        .removeClass('active');
                    localStorage.setItem("last-used-report-settings-sub-tab", $(this)[0].id);
                    $(this).addClass('active')
                })
        })();
    }

    render() {
        return (

            <div id="tabPage">
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="tab-class" style={{ marginLeft: '4px' }}>
                            <ul className="nav nav-tabs border-bottom navCluster" >
                                <Link className="nav-item" to="/projectmgmt/reports/bot-store" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="review-tab" >
                                        Reviews
                                    </li>
                                </Link>
                                <Link className="nav-item" to="/projectmgmt/reports/bot-store/tickets" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="tickets-tab" >
                                        Reported Issues
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>

                    <Route path="/projectmgmt/reports/bot-store/tickets" component={BotStoreTickets}></Route>
                    <Route path="/projectmgmt/reports/bot-store" component={Review}></Route>


                </Switch>
            </div>

        );
    }
}
export default BotStoreReportTabSetting;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/botStore/BotStoreReportTabSetting.js